/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputMissionDropData } from './OutputMissionDropData';
import {
    OutputMissionDropDataFromJSON,
    OutputMissionDropDataFromJSONTyped,
    OutputMissionDropDataToJSON,
} from './OutputMissionDropData';

/**
 * 
 * @export
 * @interface OutputHistoryEditableData
 */
export interface OutputHistoryEditableData {
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    ammo: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    customTarget: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    customTargetType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    droneSerialNumber?: string;
    /**
     * 
     * @type {Array<OutputMissionDropData>}
     * @memberof OutputHistoryEditableData
     */
    drops?: Array<OutputMissionDropData>;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    missionType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    positionId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    stockAmmoId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    stockAmmoName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputHistoryEditableData
     */
    stockDroneDeducted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    stockDroneId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    stockDroneName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputHistoryEditableData
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    target: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    targetStatus: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEditableData
     */
    targetType: number;
    /**
     * 
     * @type {boolean}
     * @memberof OutputHistoryEditableData
     */
    validateMgrs: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEditableData
     */
    video: string;
}

/**
 * Check if a given object implements the OutputHistoryEditableData interface.
 */
export function instanceOfOutputHistoryEditableData(value: object): boolean {
    if (!('ammo' in value)) return false;
    if (!('comment' in value)) return false;
    if (!('customTarget' in value)) return false;
    if (!('customTargetType' in value)) return false;
    if (!('id' in value)) return false;
    if (!('target' in value)) return false;
    if (!('targetStatus' in value)) return false;
    if (!('targetType' in value)) return false;
    if (!('validateMgrs' in value)) return false;
    if (!('video' in value)) return false;
    return true;
}

export function OutputHistoryEditableDataFromJSON(json: any): OutputHistoryEditableData {
    return OutputHistoryEditableDataFromJSONTyped(json, false);
}

export function OutputHistoryEditableDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputHistoryEditableData {
    if (json == null) {
        return json;
    }
    return {
        
        'ammo': json['ammo'],
        'comment': json['comment'],
        'customTarget': json['custom_target'],
        'customTargetType': json['custom_target_type'],
        'droneSerialNumber': json['droneSerialNumber'] == null ? undefined : json['droneSerialNumber'],
        'drops': json['drops'] == null ? undefined : ((json['drops'] as Array<any>).map(OutputMissionDropDataFromJSON)),
        'id': json['id'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'positionId': json['positionId'] == null ? undefined : json['positionId'],
        'stockAmmoId': json['stockAmmoId'] == null ? undefined : json['stockAmmoId'],
        'stockAmmoName': json['stockAmmoName'] == null ? undefined : json['stockAmmoName'],
        'stockDroneDeducted': json['stockDroneDeducted'] == null ? undefined : json['stockDroneDeducted'],
        'stockDroneId': json['stockDroneId'] == null ? undefined : json['stockDroneId'],
        'stockDroneName': json['stockDroneName'] == null ? undefined : json['stockDroneName'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'target': json['target'],
        'targetStatus': json['target_status'],
        'targetType': json['target_type'],
        'validateMgrs': json['validate_mgrs'],
        'video': json['video'],
    };
}

export function OutputHistoryEditableDataToJSON(value?: OutputHistoryEditableData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ammo': value['ammo'],
        'comment': value['comment'],
        'custom_target': value['customTarget'],
        'custom_target_type': value['customTargetType'],
        'droneSerialNumber': value['droneSerialNumber'],
        'drops': value['drops'] == null ? undefined : ((value['drops'] as Array<any>).map(OutputMissionDropDataToJSON)),
        'id': value['id'],
        'missionType': value['missionType'],
        'positionId': value['positionId'],
        'stockAmmoId': value['stockAmmoId'],
        'stockAmmoName': value['stockAmmoName'],
        'stockDroneDeducted': value['stockDroneDeducted'],
        'stockDroneId': value['stockDroneId'],
        'stockDroneName': value['stockDroneName'],
        'tags': value['tags'],
        'target': value['target'],
        'target_status': value['targetStatus'],
        'target_type': value['targetType'],
        'validate_mgrs': value['validateMgrs'],
        'video': value['video'],
    };
}

